import { render } from "./playlists.vue?vue&type=template&id=0e785ee2&ts=true"
import script from "./playlists.vue?vue&type=script&lang=ts"
export * from "./playlists.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__